import { useEffect, useRef, useState } from "react";
import "./Skeleton.css";

export function productImageUrl(file) {
  if (!file) return "";
  return `${process.env.REACT_APP_API_URL || ""}${file}`;
}

export function ProductGridImage({ src, alt = "Product" }) {
  const imgRef = useRef(null);
  const [status, setStatus] = useState(src ? "loading" : "error");

  useEffect(() => {
    if (!src) {
      setStatus("error");
      return;
    }
    const img = imgRef.current;
    if (img && img.complete) {
      setStatus(img.naturalWidth > 0 ? "loaded" : "error");
      return;
    }
    setStatus("loading");
  }, [src]);

  return (
    <div className={`pg-frame${status === "loaded" ? " is-loaded" : ""}`}>
      {status === "error" ? (
        <div className="pg-fallback" role="img" aria-label={alt} />
      ) : (
        <div className="sk pg-skeleton" aria-hidden="true" />
      )}
      {src ? (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          aria-hidden={status === "error" ? "true" : undefined}
          className={`pro_hero_img pg-photo${status === "error" ? " is-hidden" : ""}`}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      ) : null}
    </div>
  );
}
